import { createSlice } from "@reduxjs/toolkit";

import { login, resetPassword } from "./authActions";

import {
    getTokenFromLocalStorage,
    getUserFromLocalStorage,
    isLoggedIn,
} from "../../lib/utils";
import { IStateDefaults } from "../../types/shared";
import { ILocalStorageUserData } from "../../types/users";

export interface AuthState extends IStateDefaults {
    token: ILocalStorageUserData["token"] | null;
    user: ILocalStorageUserData["user"] | null;
    loggedIn: boolean;
}

const token = getTokenFromLocalStorage();
const user = getUserFromLocalStorage();

const initialState: AuthState = {
    loading: false,
    user,
    token,
    success: false,
    loggedIn: isLoggedIn(),
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        logout: state => {
            localStorage.removeItem("userData");
            state.loggedIn = false;
            state.loading = false;
            state.user = null;
            state.token = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(login.pending, state => {
                state.loading = true;
            })
            .addCase(login.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.user = payload.user;
                state.token = payload.token;
                state.loggedIn = true;
            })
            .addCase(login.rejected, state => {
                state.loading = false;
                state.loggedIn = false;
            })
            .addCase(resetPassword.pending, state => {
                state.loading = true;
                state.loggedIn = false;
            })
            .addCase(resetPassword.fulfilled, state => {
                state.loading = false;
                state.loggedIn = false;
            })
            .addCase(resetPassword.rejected, state => {
                state.loading = false;
                state.loggedIn = false;
            });
    },
});

export const authActions = {
    ...authSlice.actions,
    login: login,
    resetPassword: resetPassword,
};

export default authSlice.reducer;
